import {Page, Pages, PracticeData} from "@/libwyze-shared/types";
import {StringUtil} from "@/shared/string_util";
import {$KTS, KeyTextStrings} from "@/shared/types";
import {getMemberAuth} from "@/shared/auth";
import {MailTemplateId} from "@/libwyze-common/api/types";
import {BaseEmailCampaignFragment, Email} from "./BaseEmailCampaignFragment";
import React, {ReactElement} from "react";
import {MessageCampaignConfig, MessageCampaignConfigType} from "../BaseMessageCampaignFragment";
import {BirthdayEmailCampaignCustomizeOptions, BirthdayEmailCampaignTemplate} from "@/vantage-shared/types";

export class BirthdayEmailCampaignFragment extends BaseEmailCampaignFragment<BirthdayEmailCampaignCustomizeOptions> {

  private readonly memberAuth = getMemberAuth();

  protected createCampaignConfig(): MessageCampaignConfig {
    return {
      name: "Birthday",
      type: MessageCampaignConfigType.EMAIL,
      email: {
        title: "Send birthday email",
        text: "Send personalized birthday emails to your patients. Make your patients feel good on their special day. Simply configure the kind of message you would like to send from our collection of templates, and we'll automatically send it out at the right time.",
        subject: "Happy Birthday!",
        replaceStrings: new KeyTextStrings([
          $KTS("PRACTICE_NAME", Pages.getInstance().getListItem(PracticeData.provider().practiceId).practicePageProfile.basicInfo.name),
          $KTS("PATIENT_NAME", this.memberAuth.member.user.firstname),
        ]),
        templateId: MailTemplateId.VANTAGE_CAMPAIGNS_BIRTHDAY,
      }
    };
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    await super.fetchOnMount(forceReload);
    this.setState({
      customizeOptions: await BirthdayEmailCampaignCustomizeOptions.load(PracticeData.shared().practiceId),
    });
  }

  private replaceEmailTemplatePlaceholders(emailHtml: string, template: BirthdayEmailCampaignTemplate, practiceName: string): Email {
    return {
      subject: "Happy Birthday!",
      body: StringUtil.replacePlaceholders(emailHtml, ...this.campaignConfig.email.replaceStrings.values),
    }
  }

  private emailHtml: string;

  protected async generateMessage(practicePage: Page): Promise<Email> {
    if (!this.emailHtml) {
      this.emailHtml = await fetch("/assets/mail/vantage/campaigns/Birthday.html").then(res => res.text());
    }
    return this.replaceEmailTemplatePlaceholders(this.emailHtml, this.state.customizeOptions.template, practicePage.practicePageProfile.basicInfo.name);
  }

  protected renderPreview(email: Email): ReactElement {
    return <iframe srcDoc={email.body} style={{minHeight: 840}} frameBorder={0}/>;
  }
}